function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.15926 2.5C6.99382 2.50004 6.83441 2.5621 6.71247 2.67391C6.59054 2.78573 6.51494 2.93918 6.5006 3.104C6.39801 4.27228 6.37974 5.44643 6.44593 6.61733C6.28126 6.626 6.11726 6.63733 5.9526 6.64867L4.95926 6.72133C4.87178 6.72774 4.78746 6.75676 4.71456 6.80553C4.64165 6.85431 4.58266 6.92118 4.54335 6.99959C4.50404 7.07801 4.48576 7.16529 4.4903 7.25289C4.49485 7.34049 4.52205 7.4254 4.56926 7.49933C5.27719 8.60742 6.1894 9.57076 7.25726 10.338L7.65526 10.624C7.75591 10.6963 7.87669 10.7352 8.0006 10.7352C8.1245 10.7352 8.24529 10.6963 8.34593 10.624L8.74393 10.338C9.81179 9.57074 10.724 8.60741 11.4319 7.49933C11.4791 7.4254 11.5063 7.34049 11.5109 7.25289C11.5154 7.16529 11.4972 7.07801 11.4578 6.99959C11.4185 6.92118 11.3595 6.85431 11.2866 6.80553C11.2137 6.75676 11.1294 6.72774 11.0419 6.72133L10.0486 6.64867C9.88425 6.63678 9.7198 6.62634 9.55526 6.61733C9.62167 5.44645 9.60363 4.27229 9.50126 3.104C9.48691 2.93907 9.41122 2.78552 9.28914 2.67369C9.16707 2.56185 9.00749 2.49988 8.84193 2.5H7.15926Z",
  fill: "#2170F4"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.33337 12.6665H12.6667",
  stroke: "#2170F4",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.5d56b562.svg";
export { ForwardRef as ReactComponent };